import axios from 'axios'

export default {
 getAccountingPeriods: (page) => axios.get('/accounting_periods/quarters', {
     params: { page: page }
   }),

  postAccountingPeriod: (data) => axios.post('/accounting_periods', data)

  /* postAccountingPeriod: accountingData => Promise.resolve({
    data: {
      ...accountingData
    }
  })
  /*
  getAccountingPeriods: (page) => Promise.resolve({
    data: [
      {
        'id': 1,
        'name': '1st Quarter',
        'startDate': '2020-05-20T20:40:39.518Z',
        'endDate': '2020-05-20T20:40:39.518Z',
        'isClosed': true,
        'sign': 'string',
        'status': 'string',
        'receipts': [
          { id: 1 }, { id: 2 }
        ]
      },
      {
        'id': 2,
        'name': '2nd Quarter',
        'startDate': '2020-05-20T20:40:39.518Z',
        'endDate': '2020-05-20T20:40:39.518Z',
        isClosed: false,
        'sign': 'string',
        'status': 'string',
        'receipts': [

        ]
      }
    ]
  }) */
}
